export default "__VITE_ASSET__qF7CRRmt__"